import { render, staticRenderFns } from "./ProductCollectionItem.vue?vue&type=template&id=2119fa17&"
import script from "./ProductCollectionItem.vue?vue&type=script&lang=ts&"
export * from "./ProductCollectionItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCollectionItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports